import { Account } from 'shared/types/account';

interface GTMUser {
  user_id?: string;
  name: string;
  first_name?: string;
  last_name?: string;
  email: string;
  emailHash?: string;
  isTradeAccount: boolean;
}

export class AccountMapper {
  static fromAccountToGTMUser(account: Account): GTMUser {
    const firstName = account?.firstName ?? '';
    const lastName = account?.lastName ?? '';
    return {
      user_id: account.accountId,
      name: firstName && lastName ? firstName + ' ' + lastName : firstName,
      first_name: firstName,
      last_name: lastName,
      email: account.email,
      emailHash: account.emailHash,
      isTradeAccount: !!account.isTradeAccount,
    };
  }
}
